<template>
  <div class="home">
    <!-- 首页头部轮播图 -->
    <div class="homebody1" v-if="homeSec01Img.length > 0">
      <div class="swiper-container swiper1" :style="{ height: scrollerHeight }">
        <div class="swiper-wrapper" :style="{ height: scrollerHeight }">
          <div
            class="swiper-slide"
            v-for="(item, index) in homeSec01Img"
            :key="index"
            :style="{ height: scrollerHeight }"
          >
            <div class="homebody1bg">
              <a
                :href="item.url"
                target="_blank"
              >
                <!-- <el-image
                  style="width: 100%; height: 100%"
                  :src="item.fileName"
                  fit="cover"
                >
                </el-image> -->
                <img :src="item.fileName"/>
              </a>
            </div>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>
    <div style="clear: both"></div>
    <!-- 新闻部分 -->
    <div class="homebody2 wrap">
      <div class="homebody2newstitle">
        <a
          target="_blank"
          href="/list/02510001"
        >
          <p class="body2newstitle1">news</p>
          <p class="body2newstitle2">新闻动态</p>
        </a>
      </div>
      <div style="clear: both"></div>
      <div>
        <!-- 华陇新闻栏目 -->
        <div class="body2tit">
          <ul>
            <li
              v-for="(item, index) in body2titList"
              :key="index"
            >
              <a
                :href="item.url"
                target="_blank"
                :class="{ nav1OnCss: nav1OnList == index }"
                @mouseenter="addnav1Css(index)"
              >
                {{ item.title }}
              </a>
            </li>
          </ul>
        </div>
        <div style="clear: both"></div>
        <!-- 华陇新闻list -->
        <div class="body2list">
          <ul>
            <div
              v-if="nav1OnList == 0"
              class="wrapfill"
            >
              <li
                v-for="(item, index) in companyNewsList"
                :key="index"
              >
                <a
                  v-if="item.url && item.url !== ''"
                  target="_blank"
                  :href="item.url"
                >
                  <el-image
                    v-if="item.thumb1"
                    class="newslistimg"
                    :src="item.thumb1"
                    fit="cover"
                  >
                  </el-image>
                  <el-image
                    v-if="!item.thumb1"
                    class="newslistimg"
                    :src="gsdefaultimg"
                    fit="fill"
                  >
                  </el-image>
                  <div class="body2listcont">
                    <img
                      src="../assets/img/new.gif"
                      v-if="index == 0 || index == 1"
                      class="iconnew"
                    />
                    <div
                      :class="
                        index == 0 || index == 1 ? 'iconnewtit' : 'body2listtit'
                      "
                    >
                      {{ item.title }}
                    </div>
                    <div style="clear: both"></div>
                    <div class="body2listday">
                      {{ dayjs(item.publishDate).format("YYYY-MM-DD") }}
                    </div>
                    <div class="body2listdesc">{{ item.artDesc }}</div>
                  </div>
                </a>
                <a
                  v-else
                  target="_blank"
                  :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
                >
                  <el-image
                    v-if="item.thumb1"
                    class="newslistimg"
                    :src="item.thumb1"
                    fit="cover"
                  >
                  </el-image>
                  <el-image
                    v-if="!item.thumb1"
                    class="newslistimg"
                    :src="gsdefaultimg"
                    fit="fill"
                  >
                  </el-image>
                  <div class="body2listcont">
                    <img
                      src="../assets/img/new.gif"
                      v-if="index == 0 || index == 1"
                      class="iconnew"
                    />
                    <div
                      :class="
                        index == 0 || index == 1 ? 'iconnewtit' : 'body2listtit'
                      "
                    >
                      {{ item.title }}
                    </div>
                    <div class="body2listday">
                      {{ dayjs(item.publishDate).format("YYYY-MM-DD") }}
                    </div>
                    <div class="body2listdesc">{{ item.artDesc }}</div>
                  </div>
                </a>
              </li>
            </div>
            <div
              v-if="nav1OnList == 1"
              class="wrapfill"
            >
              <li
                v-for="(item, index) in jtNewsList"
                :key="index"
              >
                <a
                  v-if="item.url && item.url !== ''"
                  target="_blank"
                  :href="item.url"
                >
                  <el-image
                    v-if="item.thumb1"
                    class="newslistimg"
                    :src="item.thumb1"
                    fit="cover"
                  >
                  </el-image>
                  <el-image
                    v-if="!item.thumb1"
                    class="newslistimg"
                    :src="jtdefaultimg"
                    fit="fill"
                  >
                  </el-image>
                  <div class="body2listcont">
                    <img
                      src="../assets/img/new.gif"
                      v-if="index == 0 || index == 1"
                      class="iconnew"
                    />
                    <div
                      :class="
                        index == 0 || index == 1 ? 'iconnewtit' : 'body2listtit'
                      "
                    >
                      {{ item.title }}
                    </div>
                    <div class="body2listday">
                      {{ dayjs(item.publishDate).format("YYYY-MM-DD") }}
                    </div>
                    <div class="body2listdesc">{{ item.artDesc }}</div>
                  </div>
                </a>
                <a
                  v-else
                  target="_blank"
                  :href="`/detail/02510001/${item.entTArticleUuid}`"
                >
                  <el-image
                    v-if="item.thumb1"
                    class="newslistimg"
                    :src="item.thumb1"
                    fit="cover"
                  >
                  </el-image>
                  <el-image
                    v-if="!item.thumb1"
                    class="newslistimg"
                    :src="jtdefaultimg"
                    fit="fill"
                  >
                  </el-image>
                  <div class="body2listcont">
                    <img
                      src="../assets/img/new.gif"
                      v-if="index == 0 || index == 1"
                      class="iconnew"
                    />
                    <div
                      :class="
                        index == 0 || index == 1 ? 'iconnewtit' : 'body2listtit'
                      "
                    >
                      {{ item.title }}
                    </div>
                    <div class="body2listday">
                      {{ dayjs(item.publishDate).format("YYYY-MM-DD") }}
                    </div>
                    <div class="body2listdesc">{{ item.artDesc }}</div>
                  </div>
                </a>
              </li>
            </div>
            <div
              v-if="nav1OnList == 2"
              class="wrapfill"
            >
              <li
                v-for="(item, index) in grassrootsList"
                :key="index"
              >
                <a
                  v-if="item.url && item.url !== ''"
                  target="_blank"
                  :href="item.url"
                >
                  <el-image
                    v-if="item.thumb1"
                    class="newslistimg"
                    :src="item.thumb1"
                    fit="cover"
                  >
                  </el-image>
                  <el-image
                    v-if="!item.thumb1"
                    class="newslistimg"
                    :src="hydefaultimg"
                    fit="fill"
                  >
                  </el-image>
                  <div class="body2listcont">
                    <img
                      src="../assets/img/new.gif"
                      v-if="index == 0 || index == 1"
                      class="iconnew"
                    />
                    <div
                      :class="
                        index == 0 || index == 1 ? 'iconnewtit' : 'body2listtit'
                      "
                    >
                      {{ item.title }}
                    </div>
                    <div class="body2listday">
                      {{ dayjs(item.publishDate).format("YYYY-MM-DD") }}
                    </div>
                    <div class="body2listdesc">{{ item.artDesc }}</div>
                  </div>
                </a>
                <a
                  v-else
                  target="_blank"
                  :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
                >
                  <el-image
                    v-if="item.thumb1"
                    class="newslistimg"
                    :src="item.thumb1"
                    fit="cover"
                  >
                  </el-image>
                  <el-image
                    v-if="!item.thumb1"
                    class="newslistimg"
                    :src="hydefaultimg"
                    fit="fill"
                  >
                  </el-image>
                  <div class="body2listcont">
                    <img
                      src="../assets/img/new.gif"
                      v-if="index == 0 || index == 1"
                      class="iconnew"
                    />
                    <div
                      :class="
                        index == 0 || index == 1 ? 'iconnewtit' : 'body2listtit'
                      "
                    >
                      {{ item.title }}
                    </div>
                    <div class="body2listday">
                      {{ dayjs(item.publishDate).format("YYYY-MM-DD") }}
                    </div>
                    <div class="body2listdesc">{{ item.artDesc }}</div>
                  </div>
                </a>
              </li>
            </div>
            <div
              v-if="nav1OnList == 3"
              class="wrapfill"
            >
              <li
                v-for="(item, index) in mediumNewsList"
                :key="index"
              >
                <a
                  v-if="item.url && item.url !== ''"
                  target="_blank"
                  :href="item.url"
                >
                  <el-image
                    v-if="item.thumb1"
                    class="newslistimg"
                    :src="item.thumb1"
                    fit="cover"
                  >
                  </el-image>
                  <el-image
                    v-if="!item.thumb1"
                    class="newslistimg"
                    :src="hydefaultimg"
                    fit="fill"
                  >
                  </el-image>
                  <div class="body2listcont">
                    <img
                      src="../assets/img/new.gif"
                      v-if="index == 0 || index == 1"
                      class="iconnew"
                    />
                    <div
                      :class="
                        index == 0 || index == 1 ? 'iconnewtit' : 'body2listtit'
                      "
                    >
                      {{ item.title }}
                    </div>
                    <div class="body2listday">
                      {{ dayjs(item.publishDate).format("YYYY-MM-DD") }}
                    </div>
                    <div class="body2listdesc">{{ item.artDesc }}</div>
                  </div>
                </a>
                <a
                  v-else
                  target="_blank"
                  :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
                >
                  <el-image
                    v-if="item.thumb1"
                    class="newslistimg"
                    :src="item.thumb1"
                    fit="cover"
                  >
                  </el-image>
                  <el-image
                    v-if="!item.thumb1"
                    class="newslistimg"
                    :src="hydefaultimg"
                    fit="fill"
                  >
                  </el-image>
                  <div class="body2listcont">
                    <img
                      src="../assets/img/new.gif"
                      v-if="index == 0 || index == 1"
                      class="iconnew"
                    />
                    <div
                      :class="
                        index == 0 || index == 1 ? 'iconnewtit' : 'body2listtit'
                      "
                    >
                      {{ item.title }}
                    </div>
                    <div class="body2listday">
                      {{ dayjs(item.publishDate).format("YYYY-MM-DD") }}
                    </div>
                    <div class="body2listdesc">{{ item.artDesc }}</div>
                  </div>
                </a>
              </li>
            </div>
          </ul>
        </div>
      </div>
    </div>
    <div style="clear: both"></div>
    <!-- 业务范围 -->
    <div class="homebody3">
      <ul>
        <li
          v-for="(item, index) in projectlists"
          :key="index"
        >
          <a
            target="_blank"
            :href="item.url"
          >
            <p>{{ item.english }}</p>
            <p>{{ item.name }}</p>
            <p>{{ item.cont }}</p>
            <p>+</p>
          </a>
        </li>
      </ul>
    </div>
    <div style="clear: both"></div>
    <!-- 党群建设 -->
    <div class="homebody4 wrap">
      <div class="homebody2newstitle">
        <a
          target="_blank"
          href="/list/02520001"
        >
          <p class="body2newstitle1">Party building</p>
          <p class="body2newstitle2">党群建设</p>
        </a>
      </div>
      <div
        class="homebody4banner"
        style="position: relative; z-index: 99"
      >
        <a
          :href="bannerurl"
          target="_blank"
        >
          <img
            v-if="bannerlist.length > 0"
            :src="bannerlist"
            style="width: 100%; height:75px;"
          />
          <!-- object-fit: cover; -->
          <img
            v-if="!bannerlist.length"
            :src="bannerlists"
            style="width: 100%; height:75px;"
          />
        </a>
      </div>
      <div class="homebody4news">
        <ul>
          <li
            v-for="(item, index) in PartyList"
            :key="index"
          >
            <a 
              :href="item.url" 
              target="_blank" 
              v-if=" item.url && item.url !== '' "
            >
              <img
                src="../assets/img/new.gif"
                v-if="index == 0 || index == 1"
                class="iconnew4"
              />
              <p
                :class="
                  index == 0 || index == 1 ? 'iconnew4p' : 'homebody4newstit'
                "
              >
                {{ item.title }}
              </p>
              <div style="clear: both"></div>
              <p class="homebody4artDesc">{{ item.artDesc }}</p>
              <p class="homebody4data">{{ item.data }}</p>
            </a>
            <a 
            v-if="item.url == null"
              :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
              target="_blank">
              <img
                src="../assets/img/new.gif"
                v-if="index == 0 || index == 1"
                class="iconnew4"
              />
              <p
                :class="
                  index == 0 || index == 1 ? 'iconnew4p' : 'homebody4newstit'
                "
              >
                {{ item.title }}
              </p>
              <div style="clear: both"></div>
              <p class="homebody4artDesc">{{ item.artDesc }}</p>
              <p class="homebody4data">{{ item.data }}</p>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div style="clear: both"></div>
    <!-- 华陇公司概况 -->
    <div class="homebody5">
      <div class="homebody5all wrap">
        <div class="homebody2newstitle">
          <a
            target="_blank"
            href="/listPage/02500001"
          >
            <p class="body2newstitle1">hualong - nengchuang</p>
            <p class="body2newstitle2">公司概况</p>
          </a>
        </div>
        <div class="homebody5bot">
          <div class="homebody5botl">
            <!-- 宣传视频 -->
            <!-- <a href="/list/02320001" target="_blank"> -->
              <video
                muted="muted"
                type="video/mp4"
                src="../assets/video/nengchuang.mp4"
                poster="../assets/video/nengchuang.png"
                controls
                loop
              ></video>
            <!-- </a> -->
          </div>
          <div class="homebody5botr">
            <div class="homebody5introduce">
              <a href="/listPage/02500001" target="_blank">华陇能创股份有限公司简介</a>
              <p>
                华陇能创股份有限公司是按照省委省政府安排部署,由省政府国资委协调,甘肃建投、甘肃城乡集团、甘肃电投、甘肃能化4家省属骨干企业共同发起组建的国有全资股份有限公司,
                于2020年5月22日正式揭牌运营。
              </p>
              <a href="/listPage/02500001" target="_blank">了解更多</a>
            </div>
          </div>
          <div style="clear: both"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
import { getAdvert, articles, getChildChannel } from "@/api/common";
export default {
  components: {
    // windowBox,
  },
  name: "home",
  data() {
    return {
      // 首页头部轮播图
      screenWidth: document.body.clientWidth,  //头部轮播图比例
      centerBanner: "",
      homeSec01Img: [],
      homeSec01Imgs: [
        { fileName: require("../assets/image/homeSec01Top1.jpg") },
        { fileName: require("../assets/image/homeSec01Top2.jpg") },
        { fileName: require("../assets/image/homeSec01Top3.jpg") },
        { fileName: require("../assets/image/homeSec01Top4.jpg") },
      ],
      // 新闻栏目
      nav1OnList: 0,
      body2titList: [
        {
          title: "公司新闻",
          url: "/list/02510002",
        },
        {
          title: "集团要闻",
          url: "/list/02510001",
        },
        {
          title: "行业资讯",
          url: "/list/02510003",
        },
        {
          title: "媒体关注",
          url: "/list/02510004",
        },
      ],
      // 新闻列表数据
      companyNewsList: [],  // 公司新闻
      jtNewsList: [],  // 集团要闻
      grassrootsList: [],  // 行业资讯
      mediumNewsList: [],  // 媒体关注
      gsdefaultimg: require("../assets/image/gsdefault.jpg"),
      jtdefaultimg: require("../assets/image/jtdefault.jpg"),
      hydefaultimg: require("../assets/image/hydefault.jpg"),
      mtdefaultimg: require("../assets/image/hydefault.jpg"),
      // 新闻列表假数据
      homeSec02Imgs: [
        {
          title: "中央和省级媒体走进甘肃建投活动第一站圆满结束",
          artDesc: "6月21日，中央和省级媒体走进甘肃建投活动第一站圆满结束。",
          url: "/detail/02310004/f7d972f71eb811ee8834902e163331ac",
          thumb1: require("../assets/image/Sec02L1.jpg"),
        },
        {
          title:
            "【安全生产月】打好“安全战” 安装公司开展“安全生产月”应急演练活动",
          artDesc:
            "6月20日，安装公司在永登县污水处理中心提标改造工程开展2023年“安全生产月”应急演练活动，永登县消防救援大队、永登县人民医院联合参演。",
          url: "/detail/02310001/f7d763b71eb811ee8834902e163331ac",
          thumb1: require("../assets/image/Sec02L2.jpg"),
        },
        {
          title: "安装公司召开“七一”表彰大会",
          artDesc:
            "6月16日，安装公司在湖南韶山开展红色教育实践活动，召开“七一”表彰大会，表彰2022年度“两优一先”“双优党支部”、优秀通讯员、优秀宣传稿，以及2023年度廉洁文化建设宣传获奖作品。",
          url: "/detail/02310001/f7d758bf1eb811ee8834902e163331ac",
          thumb1: require("../assets/image/Sec02L1.jpg"),
        },
        {
          title: "安装公司2023年度BIM应用大赛启动会",
          artDesc:
            "6月13日，公司召开“2023年度安装公司BIM应用大赛”启动会，科技研发中心（BIM）人员、工程公司主任工程师、BIM技术相关人员参加了此次会议。",
          url: "/detail/02310001/f7d753391eb811ee8834902e163331ac",
          thumb1: require("../assets/image/Sec02L2.jpg"),
        },
        {
          title: "安装公司职工荣获甘肃省技能（BIM）竞赛奖项",
          artDesc:
            "6月17日、18日，2023年甘肃省百万职工劳动和技能竞赛“BIM技术”省级二类决赛，在甘肃建筑职业技术学院举行。经激烈角逐，安装公司职工康云在比赛中名列15名，荣获二等奖。",
          url: "/detail/02310001/f7d74b501eb811ee8834902e163331ac",
          thumb1: require("../assets/image/Sec02L1.jpg"),
        },
      ],
      homeSec02Imgsfaek: [
        {
          data: "2024-05-06",
          title:
            "【安全生产月】打好“安全战” 安装公司开展“安全生产月”应急演练活动",
          artDesc:
            "6月20日，安装公司在永登县污水处理中心提标改造工程开展2023年“安全生产月”应急演练活动，永登县消防救援大队、永登县人民医院联合参演。",
          url: "/detail/02310001/f7d763b71eb811ee8834902e163331ac",
          thumb1: require("../assets/image/Sec02L2.jpg"),
        },
        {
          data: "2024-05-06",
          title: "安装公司召开“七一”表彰大会",
          artDesc:
            "6月16日，安装公司在湖南韶山开展红色教育实践活动，召开“七一”表彰大会，表彰2022年度“两优一先”“双优党支部”、优秀通讯员、优秀宣传稿，以及2023年度廉洁文化建设宣传获奖作品。",
          url: "/detail/02310001/f7d758bf1eb811ee8834902e163331ac",
          thumb1: require("../assets/image/Sec02L1.jpg"),
        },
        {
          data: "2024-05-06",
          title: "安装公司2023年度BIM应用大赛启动会",
          artDesc:
            "6月13日，公司召开“2023年度安装公司BIM应用大赛”启动会，科技研发中心（BIM）人员、工程公司主任工程师、BIM技术相关人员参加了此次会议。",
          url: "/detail/02310001/f7d753391eb811ee8834902e163331ac",
          thumb1: require("../assets/image/Sec02L2.jpg"),
        },
        {
          data: "2024-05-06",
          title: "中央和省级媒体走进甘肃建投活动第一站圆满结束",
          artDesc: "6月21日，中央和省级媒体走进甘肃建投活动第一站圆满结束。",
          url: "/detail/02310004/f7d972f71eb811ee8834902e163331ac",
          thumb1: require("../assets/image/Sec02L1.jpg"),
        },
        {
          data: "2024-05-06",
          title: "安装公司职工荣获甘肃省技能（BIM）竞赛奖项",
          artDesc:
            "6月17日、18日，2023年甘肃省百万职工劳动和技能竞赛“BIM技术”省级二类决赛，在甘肃建筑职业技术学院举行。经激烈角逐，安装公司职工康云在比赛中名列15名，荣获二等奖。",
          url: "/detail/02310001/f7d74b501eb811ee8834902e163331ac",
          thumb1: require("../assets/image/Sec02L1.jpg"),
        },
      ],
      // 业务范围
      projectlist: [],
      projectlists: [
        {
          english: "FUEL GAS",
          name: "城乡燃气",
          cont: "华陇能创股份有限公司的城乡燃气业务",
          pic: require("../assets/image/itemPic1.png"),
          url: "/list/02530001",
        },
        {
          english: "NEW ENERGY",
          name: "新能源",
          cont: "华陇能创股份有限公司的新能源业务",
          pic: require("../assets/image/itemPic2.png"),
          url: "/list/02530002",
        },
        {
          english: "CONSTRUCTION",
          name: "建安板块",
          cont: "华陇能创股份有限公司的建安板块业务",
          pic: require("../assets/image/itemPic3.png"),
          url: "/list/02530003",
        },
        {
          english: "COMMERCIAL SUPPLY",
          name: "商贸供应",
          cont: "华陇能创股份有限公司的商贸供应业务",
          pic: require("../assets/image/itemPic4.png"),
          url: "/list/02530004",
        },
        {
          english: "HEATING",
          name: "城乡供热",
          cont: "华陇能创股份有限公司的城乡供热业务",
          pic: require("../assets/image/itemPic5.png"),
          url: "/list/02530005",
        },
        {
          english: "NEW ENERGY",
          name: "新能源技术研发",
          cont: "华陇能创股份有限公司的新能源技术研发业务",
          pic: require("../assets/image/itemPic4.png"),
          url: "/list/02530006",
        },
      ],
      // 党群建设
      PartyList: [],  // 媒体关注
      // 中间banner
      bannerurl: undefined,
      bannerlist: [],
      bannerlists: require("../assets/image/partymiduim.jpg"),
    };
  },
  filters: {
    //超过100位显示 ...
    ellipsis: function (value) {
      if (!value) return "";
      if (value.length > 125) {
        return value.slice(0, 125) + "...";
      }
      return value;
    },
  },
  mounted() {
    // top轮播图比例
    var _this = this
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        _this.screenWidth = window.screenWidth
      })
    }
    // 华陇首页图片
    setTimeout(() => {
      this.swiper1TopNews();
    }, 500);
    // 新闻列表
    this.companyNews();
    this.jtNews();
    this.grassroots();
    this.mediumNews();
    // 业务范围nav
    // this.projectnavlist();  //有描述信息和英文名所以写死了
    // 党建动态
    this.getPartydata();
    // 华陇homebody4banner
    this.getbanner();
  },
  watch: {
    screenWidth(val) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenWidth = val
        this.timer = true
        let that = this
        setTimeout(function() {
          // 打印screenWidth变化的值
          console.log(that.screenWidth)
          that.timer = false
        }, 400)
      }
    }
  },
  computed: {
    scrollerHeight() {
      return this.screenWidth / 3.22 + 'px'
    },
  },
  methods: {
    // banner首页头部轮播图
    swiper1TopNews() {
      var _this = this;
      let data = {
        applicationUuid: _this.webId,
        advertType: 1,
      };
      getAdvert(data).then((res) => {
        const { code, data } = res;
        if (code === 1 && data) {
          data.length &&
            data.forEach((line) => {
              if (line.fileName && line.fileName !== "") {
                _this.homeSec01Img.push(line);
              }
            });
          if(data.length == 0) {
            _this.homeSec01Img = this.homeSec01Imgs
          }
          setTimeout(() => {
            new Swiper(".swiper1", {
              loop: true,
              effect: "fade",
              autoplay: 2000,
              // speed: 1000,
              // prevButton:'.swiper-button-prev',
              // nextButton:'.swiper-button-next',
              observer: true,
              observeParents: true,
              observeSlideChildren: true,
              autoplayDisableOnInteraction: false,
              pagination: ".swiper-pagination",
            });
          }, 500);
        }
      });
      // let data2 = {
      //   applicationUuid: _this.webId,
      //   advertType: 3,
      // };
      // getAdvert(data2).then((res) => {
      //   const { code, data } = res;
      //   if (code === 1 && data) {
      //     if(data.length > 0){
      //       _this.centerBanner = data[0].fileName;
      //     }
      //   }
      // });
    },
    // 新闻列表轮播
    addnav1Css(index) {
      this.nav1OnList = index;
    },
    // 公司新闻
    companyNews() {
      var _this = this;
      let data = {
        channelUuid: "02510002", 
        entTApplicationUuid: _this.webId,
        pageNum: 1,
        pageSize: 4,
      };
      articles(data).then((res) => {
        const { code, data } = res;
        if (code === 1 && data) {
          _this.companyNewsList = data.rows;
        }
      });
    },
    // 集团要闻
    jtNews() {
      var _this = this;
      let data = {
        channelUuid: "00190001",
        // channelUuid: "02510001",
        entTApplicationUuid: _this.webIdGroup,
        pageNum: 1,
        pageSize: 4,
      };
      articles(data).then((res) => {
        const { code, data } = res;
        if (code === 1 && data) {
          _this.jtNewsList = data.rows;
        }
      });
    },
    // 行业资讯
    grassroots() {
      var _this = this;
      let data = {
        channelUuid: "02510003",
        entTApplicationUuid: _this.webId,
        pageNum: 1,
        pageSize: 4,
      };
      articles(data).then((res) => {
        const { code, data } = res;
        if (code === 1 && data) {
          _this.grassrootsList = data.rows;
        }
      });
    },
    // 媒体关注
    mediumNews() {
      var _this = this;
      let data = {
        channelUuid: "02510004",
        entTApplicationUuid: _this.webId,
        pageNum: 1,
        pageSize: 4,
      };
      articles(data).then((res) => {
        const { code, data } = res;
        if (code === 1 && data) {
          _this.mediumNewsList = data.rows;
        }
      });
    },
    // 业务范围 未使用
    projectnavlist() {
      var _this = this;
      let data = {
        applicationUuid: _this.webId,
        parentUuid: "0253",
      };
      getChildChannel(data).then((res) => {
        const { code, data } = res;
        if (code === 1 && data) {
          _this.projectlist = data;
        }
      });
    },
    // 媒体关注
    getPartydata() {
      var _this = this;
      let data = {
        channelUuid: "02520001",
        entTApplicationUuid: _this.webId,
        pageNum: 1,
        pageSize: 3,
      };
      articles(data).then((res) => {
        const { code, data } = res;
        if (code === 1 && data) {
          _this.PartyList = data.rows;
        }
      });
    },
    // homebody4banner图
    getbanner() {
      var _this = this;
      let data = {
        applicationUuid: _this.webId,
        advertType: 3,
      };
      getAdvert(data).then((res) => {
        const { code, data } = res;
        if (code === 1 && data) {
          data.length && (_this.bannerlist = data[0].fileName);
          if(data.length > 0){
            _this.bannerurl = data[0].url;
          }
        }
      });
    },
  },
};
</script>
<style>
.homebody1 {
  height: auto;
  width: 100%;
  /* margin-bottom: 40px; */
}
.homebody1 .swiper-container,
.homebody1 .swipertop1 .swiper-wrapper,
.homebody1 .swipertop1 .swiper-slide {
  width: 100%;
  height: auto;
  /* max-height: 490px; */
}
.homebody1 .swiper-container {
  position: relative;
  overflow: hidden;
}
.homebody1 .swiper-slide {
  opacity: 0; /* 默认所有滑块不可见 */
  transition: opacity 0.5s ease;
}
.homebody1 .swiper-slide-active {
  opacity: 1; /* 只有当前活动的滑块可见 */
}
.homebody1bg {
  width: 100%;
  height: 100%;
}
.homebody1bg img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.homeSec02 {
  height: auto;
}
.homebody2,
.homebody4 {
  padding: 90px 15px;
}
.homebody2newstitle {
  color: #323232;
  text-align: center;
  margin-bottom: 50px;
}
.homebody2newstitle a {
  display: inline-block;
}
.homebody2newstitle a:hover {
  color: #0062b3;
}
.body2newstitle1 {
  font-size: 48px;
  line-height: 48px;
  font-weight: bold;
  text-transform: uppercase;
  margin-bottom: 10px;
}
.body2newstitle2 {
  font-size: 30px;
  line-height: 30px;
}
.body2tit {
  text-align: center;
  margin-bottom: 40px;
}
.body2tit a:hover,
.nav1OnCss {
  background-color: rgb(0, 98, 177);
  color: #ffffff;
  transition: all 0.3s linear;
}
.body2tit ul li {
  display: inline-block;
  margin: 0 10px;
}
.body2tit ul li a {
  display: block;
  padding: 0 20px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  border: 1px solid #dcdcdc;
  border-radius: 18px;
  font-size: 16px;
}
.body2list {
  height: 490px;
  overflow: hidden;
}
.body2list ul {
  height: 100%;
}
.body2list .wrapfill {
  height: 100%;
  width: 100%;
}
.body2list ul li {
  width: 58%;
  height: 29.6%;
  float: right;
  margin-bottom: 2%;
}
.body2list ul li a {
  display: inline-block;
  width: 100%;
  height: 100%;
}
.body2list a .newslistimg {
  width: 30%;
  height: 100%;
  float: left;
  margin-right: 3%;
}
.body2list a .body2listcont {
  float: right;
  width: 67%;
}
.iconnew {
  float: left;
  margin: 20px 5px 0 0;
}
.iconnewtit {
  float: right;
  width: calc(100% - 35px);
  font-size: 20px;
  height: 32px;
  line-height: 32px;
  margin: 10px 0;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all;
}
.body2list a .body2listcont .body2listtit {
  font-size: 20px;
  height: 32px;
  line-height: 32px;
  margin: 10px 0;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all;
}
.body2list ul li a:hover .body2listcont .body2listtit ,
.body2list ul li a:hover .body2listcont .iconnewtit {
  color: #0062b3;
}
.body2list a .body2listcont .body2listday {
  color: #ababab;
  margin: 5px 0 10px;
}
.body2list a .body2listcont .body2listdesc {
  color: #ababab;
  height: 48px;
  line-height: 24px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-all;
}
.body2list ul li:first-child {
  width: 40%;
  height: 100%;
  margin-right: 2%;
  float: left;
  margin-bottom: 0;
}
.body2list ul li:first-child a .newslistimg {
  width: 100%;
  height: 60%;
  margin-right: 3%;
}
.body2list ul li:first-child a .body2listcont {
  width: 100%;
  position: relative;
}
.body2list ul li:first-child a .body2listcont .body2listtit {
  font-size: 24px;
  margin: 20px 0;
}
.body2list ul li:first-child a .body2listcont .body2listday {
  margin-top: 15px;
  position: relative;
  bottom: -64px;
}
.body2list ul li:first-child a .body2listcont .body2listdesc {
  position: relative;
  top: -30px;
}
.homebody3 {
  width: 100%;
  height: 800px;
  background: url(../assets/image/homebody3bg.jpg) no-repeat fixed;
  background-size: cover;
}
.homebody3 ul {
  width: 100%;
  height: 100%;
}
.homebody3 ul li {
  float: left;
  height: 100%;
  width: calc(100% / 6);
}
.homebody3 ul li a {
  display: block;
  width: 100%;
  height: 100%;
  border-right: 1px solid rgba(255, 255, 255, 0.3);
  box-sizing: border-box;
  padding: 50px 40px 0;
  color: #fff;
  -webkit-transition: All 0.4s ease-in-out;
}
.homebody3 ul li a:hover {
  background: rgba(0, 98, 179, 0.9);
}
.homebody3 ul li a p:nth-child(1) {
  font-size: 24px;
  text-transform: uppercase;
  font-weight: bold;
  width: 200px;
  height: 40px;
  -webkit-transform: rotate(90deg);
  -webkit-transform-origin: 15px 15px;
}
.homebody3 ul li a p:nth-child(2) {
  margin-top: 400px;
  font-size: 24px;
  font-weight: bold;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all;
  margin-bottom: 20px;
}
.homebody3 ul li a p:nth-child(3) {
  opacity: 0.5;
  line-height: 28px;
  height: 56px;
  margin-bottom: 40px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-all;
}
.homebody3 ul li a p:nth-child(4) {
  display: inline-block;
  border: 1px solid #fff;
  font-size: 30px;
  line-height: 32px;
  width: 40px;
  height: 40px;
  text-align: center;
  font-weight: bold;
  box-sizing: border-box;
}
.homebody4banner {
  margin-bottom: 25px;
}
.homebody4news ul {
  height: 169px;
  overflow: hidden;
}
.homebody4news ul li {
  width: calc(100% / 3 - 30px);
  float: left;
  padding: 15px;
}
.homebody4news ul li a .homebody4newstit {
  font-size: 18px;
  line-height: 30px;
  height: 30px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all;
  color: #333;
}
.homebody4news ul li a:hover .iconnew4p,
.homebody4news ul li a:hover .homebody4newstit {
  color: #0062b3;
}
.iconnew4 {
  float: left;
  margin: 9px 5px 0 0;
}
.iconnew4p {
  float: right;
  width: calc(100% - 35px);
  font-size: 18px;
  line-height: 30px;
  height: 30px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all;
  color: #333;
}
.homebody4news ul li a .homebody4artDesc {
  color: rgba(0, 0, 0, 0.5);
  line-height: 24px;
  height: 48px;
  margin: 20px 0;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-all;
}
.homebody4news ul li a .homebody4data {
  color: rgba(0, 0, 0, 0.5);
  font-family: Avenir, Helvetica, Arial, sans-serif;
}
.homebody5 {
  background: url(../assets/image/homebody5bg.jpg) 50% no-repeat fixed;
  background-size: cover;
}
.homebody5all {
  padding: 90px 15px;
}
video {
  width: 100%;
  object-fit: fill;
}
.homebody5bot {
  margin: -15px;
}
.homebody5bot .homebody5botl,
.homebody5bot .homebody5botr {
  float: left;
  width: calc(50% - 30px);
  padding: 15px;
}
.homebody5botr .homebody5introduce {
  padding-left: 70px;
  margin-top: 66px;
}
.homebody5botr .homebody5introduce a:nth-child(1) {
  display: inline-block;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
}
.homebody5botr .homebody5introduce a:nth-child(1):hover {
  color: #0062b3;
}
.homebody5botr .homebody5introduce p {
  line-height: 28px;
  height: 84px;
  opacity: 0.5;
  margin-bottom: 40px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  word-break: break-all;
}
.homebody5botr .homebody5introduce a:nth-child(3) {
  display: inline-block;
  background: #0062b3;
  border: 1px solid #0062b3;
  color: #fff;
  padding: 10px 70px;
}
.swiper-pagination-bullet-active,
.swiper-pagination-bullet {
  width: 10px;
  height: 10px;
  background-color: rgb(0, 0, 0);
  border-radius: 50px;
}
.swiper-pagination-bullet-active {
  background-color: #337ab7;
}
@media (max-width: 1430px) {
}
@media (max-width: 1200px) {
}
@media (max-width: 992px) {
  .homebody2,
  .homebody4 {
    padding: 45px 15px;
  }

  .body2tit {
    margin-bottom: 20px;
  }
  .body2tit ul li a {
    padding: 0 5px;
    border-radius: 0;
  }
  .homebody2newstitle {
    margin-bottom: 25px;
  }
  .body2newstitle1 {
    font-size: 30px;
    line-height: 30px;
  }
  .body2newstitle2 {
    font-size: 20px;
  }
  .body2list {
    height: 1000px;
  }
  .body2list ul li:first-child {
    height: 455px;
    width: 100%;
  }
  .body2list ul li {
    width: 100%;
    height: 121px;
  }
  .body2list ul li:first-child a .newslistimg {
    height: 80%;
  }
  .body2list ul li:first-child a .body2listcont .body2listtit {
    font-size: 16px;
    margin: 10px 0 0;
  }
  .body2list ul li:first-child a .body2listcont .body2listdesc {
    display: none;
  }
  .body2list ul li:first-child a .body2listcont .body2listday {
    bottom: 0;
  }
  .body2list a .body2listcont .body2listtit {
    font-size: 16px;
    margin: 0;
  }
  .body2list a .body2listcont .body2listdesc {
    display: none;
  }
  .homebody3 {
    height: 400px;
  }
  .homebody3 ul li {
    width: calc((100% - 0px) / 3);
    float: left;
    height: 50%;
  }
  .homebody3 ul li a {
    padding: 10px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  }
  .homebody3 ul li a p:nth-child(2) {
    margin-top: 50px;
    font-size: 14px;
  }
  .homebody3 ul li a p:nth-child(3) {
    opacity: 0.5;
    line-height: 20px;
    height: 40px;
    margin-bottom: 0;
    font-size: 12px;
  }
  .homebody3 ul li a p:nth-child(4) {
    font-size: 20px;
    line-height: 15px;
    width: 20px;
    height: 20px;
  }
  .homebody4banner {
    margin-bottom: 5px;
  }
  .homebody4news ul {
    height: 447px;
  }
  .homebody4news ul li {
    width: 100%;
    padding: 15px;
  }
  .homebody4news ul li a p:nth-child(2) {
    margin: 10px 0;
  }

  .homebody5all {
    padding: 45px 15px;
  }
  .homebody5bot .homebody5botl,
  .homebody5bot .homebody5botr {
    width: 100%;
  }
  .homebody5botr .homebody5introduce {
    padding-left: 0;
    margin-top: 0px;
  }
}
@media (max-width: 768px) {
}
</style>
